// extracted by mini-css-extract-plugin
module.exports = {"section":"section__1N2Kd","section-inner":"section-inner__1p4Y0","title":"title__aQsee","body":"body__27Abt"};